import { render, staticRenderFns } from "./form_agent_type.vue.js?vue&type=template&id=83598b0a&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form_agent_type.vue?vue&type=template&id=83598b0a&vue3"
import script from "./form_agent_type.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form_agent_type.vue?vue&type=script&lang=js&vue3"
export * from "./form_agent_type.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form_agent_type.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports